//@vendor
const Immutable = require('immutable');
//@actions
const actionTypes = require('../../loansConstants/actionTypes');
//@utilities
const DateHelper = require('utilities/dateHelper');
//@constants
const { EURO_TEXT } = require('constants/index');

const initialState = Immutable.fromJS({
    isFetching: false,
    error: false,
    success: false,
    details: []
});

function mapDetails(state, details) {

    const mappedDetails = details.map(detail => {
        return {
            concept: detail.conceptoLiquidacionDESCABRE,
            startDate: DateHelper.formatDate(detail.fechIniciValidzCondicionesFECOMVAL),
            endDate: DateHelper.formatDate(detail.fechaFinValidezCondFEFINVAL),
            rate: detail.tasaTASA,

            import: {
                amount: detail.importeIMPLIQ3 || 0,
                currency: EURO_TEXT
            },
            importSign: detail.signoImporteCODENT
        };
    });

    return state.mergeDeep({
        isFetching: false,
        error: false,
        success: true,
        details: mappedDetails
    });
}

// this is a subreducer
function LoanSettlementsDetailsReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.FETCH_LOAN_SETTLEMENTS_DETAILS:
            return state.merge({
                isFetching: true,
                error: false,
                success: false,
            });
        case actionTypes.FETCH_LOAN_SETTLEMENTS_DETAILS_SUCCESS:
            return mapDetails(state, action.payload.details);
        case actionTypes.FETCH_LOAN_SETTLEMENTS_DETAILS_FAILURE:
            return state.merge({
                isFetching: false,
                error: action.payload.error,
                success: false,
            });
        default:
            return state;
    }
}

module.exports = LoanSettlementsDetailsReducer;
